// This file is imported from the theme, but it's easier to find if we colocate it with the component.
import { space } from '@bottlebooks/design-tokens';
// Styles to normalize styles between button and link.
const normalize = {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    fontWeight: 'inherit',
    fontFamily: 'inherit',
    border: 0,
    backgroundColor: 'transparent',
    padding: 0,
    textAlign: 'left',
};
const linkVariants = {
    default: Object.assign(Object.assign({}, normalize), { color: 'primary', textDecoration: 'none', ':hover': { color: 'secondary', textDecoration: 'underline' }, ':visited': { color: 'primary' } }),
    text: Object.assign(Object.assign({}, normalize), { color: 'inherit', textDecoration: 'none', opacity: 1, transition: 'opacity', ':hover': { color: 'inherit', opacity: 0.85 }, ':focus': { textDecoration: 'none', color: 'inherit' } }),
    secondary: Object.assign(Object.assign({}, normalize), { color: 'inherit', textDecoration: 'none', opacity: 1, transition: 'color', ':hover': { color: 'secondary' }, ':focus': { textDecoration: 'none', color: 'secondary' } }),
    // The base variant for a button link, is used by the <Button> component.
    // Those styles are applied to all buttons and have to be overriden.
    button: {
        variant: 'text.small',
        display: 'inline-block',
        textDecoration: 'none',
        paddingX: 2,
        paddingY: 1,
        backgroundColor: 'transparent',
        borderRadius: 'default',
        borderColor: 'border',
    },
    menu: {
        color: 'text',
        backgroundColor: 'transparent',
        textDecoration: 'none',
        display: 'inline-block',
        paddingX: 3,
        paddingTop: 3,
        paddingBottom: space[3] - 2,
        border: 0,
        borderBottom: 2,
        borderColor: 'transparent',
        ':hover': { color: 'secondary' },
    },
};
export default linkVariants;
//# sourceMappingURL=linkVariants.js.map